import { exp } from "./export";

exp.getPeyoteStrip = strip => {
    let result = {rows: []};
    let myRow, ignoreRow;

    result.rows.push(strip.rows[0]); // first two rows are combined

    strip.rows.forEach((row, j) => {
        if (j > 0) {
            myRow = [];

            row.forEach((bead, i) => {
                if (exp.offsetPattern[i]) {
                    myRow.push(bead);
                }
            });
            result.rows.push(myRow);

            myRow = [];
            ignoreRow = false;
            row.forEach((bead, i) => {
                if (!exp.offsetPattern[i]) {
                    if (bead.ignore) ignoreRow = true; // ignore the last ghost row
                    myRow.push(bead);
                }
            });
            if (!ignoreRow) result.rows.push(myRow);
        }
    });

    return result;
};
